<template>
  <b-modal
    id="modal-change-log"
    ref="modal-change-log"
    header-bg-variant="primary"
    modal-class="modal-right-drawer"
    scrollable
    static
    hide-footer
    @shown="$emit('shown')"
    @hidden="$emit('hidden')"
  >
    <template #modal-header="{ close }">
      <h5 class="modal-title text-white">
        {{ title }}
      </h5>
      <button type="button" class="close text-white" @click="close">&times;</button>
    </template>

    <slot />
  </b-modal>
</template>

<script>
export default {
  name: 'ModalChangeLog',

  props: ['title'],

  methods: {
    show() {
      this.$refs['modal-change-log'].show()
    },

    hide() {
      this.$refs['modal-change-log'].hide()
    },
  },
}
</script>

<style lang="scss">
@import './log-style.scss';
</style>
